import React from "react";
import { Button, Dropdown, Menu } from "antd";

const DropdownButton = () => {
    const menu = (
        <Menu>
            <Menu.Item key="1">Editar foto de portada</Menu.Item>
        </Menu>
    );

    return (
        <Dropdown overlay={menu} trigger={["click"]}>
            <Button 
                type="primary"
                size="large"
                style={{
                    background: "#F18B6F",
                    borderColor: "#F18B6F",
                    color: "white",
                    opacity: "80%",
                    display: "none"
                }}  
            >
                ...
            </Button>
        </Dropdown>
    );
};

export default DropdownButton;